import storeManager from '../store/StoreManager';
import sessionReader from '../store/readHelpers/SessionReader';
import assessmentReader from '../store/readHelpers/AssessmentReader';
import responseActions from '../actions/ResponseActions';

// a map with contentRevisionId as key. Holds the latest timestamps used as reference for appending seconds
// to duration
const durationReferenceTimestamps = {};

const durationTrackingService = {
    DURATION_UPDATE_THROTTLE_LIMIT: 3,

    /**
     * Sets a new reference timestamp for duration calculation. As duration is calculated as
     * current duration +
     * a diff from entering a question and now
     * or
     * a diff from last time duration was updated and now
     * @param contentRevisionId
     */
    setNewDurationReferenceTimestamp(contentRevisionId) {
        durationReferenceTimestamps[contentRevisionId] = Date.now();
    },

    getSecondsSinceLastReferenceTimestamp(contentRevisionId) {
        const lastTimestamp = durationReferenceTimestamps[contentRevisionId];
        if (lastTimestamp > 0) {
            return Math.round((Date.now() - lastTimestamp) / 1000);
        }
        return 0;
    },

    /**
     * Gets the latest reference timestamp for the question, adds now to it triggers the
     * RESPONSE_ADD_SECONDS_TO_DURATION action
     * @param contentRevisionId
     */
    setDurationOnResponse(contentRevisionId) {
        if (!sessionReader.isContextExam()) {
            return false;
        }

        const question = assessmentReader.getQuestion(contentRevisionId);
        if (question) {
            // only set duration on questions
            const secondsSinceLastTimestamp = this.getSecondsSinceLastReferenceTimestamp(contentRevisionId);
            storeManager.dispatch(
                responseActions.addSecondsToDuration(question.contentRevisionId, secondsSinceLastTimestamp),
            );

            // set a new reference timestamp, as duration now has been updated on the response
            this.setNewDurationReferenceTimestamp(contentRevisionId);
            return true;
        }
        return false;
    },
};

export default durationTrackingService;
